import { useCallback } from 'react';
import { store } from '../app/store';

const CONFIRM_MESSAGE = 'Hai modifiche non salvate nel merchandising plan. Vuoi uscire senza salvare?';

/**
 * SPJ-1372: guardia per la navigazione interna (SPA) quando l'editor del
 * Merchandising Plan ha modifiche non salvate.
 *
 * Ritorna `true` se la navigazione puo' procedere (nessuna modifica in sospeso,
 * oppure l'utente ha confermato di voler uscire senza salvare), `false` se
 * l'utente ha annullato.
 *
 * Legge il flag direttamente da `store.getState()` cosi' da essere sicura anche
 * se richiamata da gestori con closure "stantie". Va invocata nei gestori UI
 * (onClick) PRIMA del dispatch di navigazione, mai dentro reducer/thunk.
 */
export function confirmLeaveUnsavedMp(): boolean {
  const hasUnsaved = store.getState().thread.hasUnsavedMpChanges;
  if (!hasUnsaved) {
    return true;
  }
  return window.confirm(CONFIRM_MESSAGE);
}

/** Variante hook, per comodita' nei componenti. */
export function useConfirmLeaveUnsavedMp(): () => boolean {
  return useCallback(() => confirmLeaveUnsavedMp(), []);
}
